// extracted by mini-css-extract-plugin
module.exports = {"container":"ng-z","products":"og-z","cta":"pg-z","disabled":"qg-z"};